export class FinaliseAba {
    UserName: string;
    ProcessingDate: string;
    Country: string;
}